import { type Maybe, WorkType } from 'src/graphql/generated';

export const getDeriveWorkType =
  ({
    fullTimeLabel,
    partTimeLabel,
    casualLabel,
    contractLabel,
  }: {
    fullTimeLabel: string;
    partTimeLabel: string;
    contractLabel: string;
    casualLabel: string;
  }) =>
  (workType?: Maybe<WorkType>) => {
    switch (workType) {
      case WorkType.FULLTIME:
        return fullTimeLabel;
      case WorkType.PARTTIME:
        return partTimeLabel;
      case WorkType.CONTRACT_TEMP:
        return contractLabel;
      case WorkType.CASUAL:
        return casualLabel;
      default:
        return WorkType.FULLTIME;
    }
  };
